import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Link } from 'react-router-dom';

import iconHabitation from 'assets/images/icon_habitation.svg';
import iconSanteMob from 'assets/images/icon_sante-mob.svg';
import iconMutuelle from 'assets/images/icon_mutuelle.svg';
import iconRc from 'assets/images/icon_RC.svg';
import iconMultimedia from 'assets/images/icon_multimedia.svg';
import newOffer from "../../../assets/images/new.gif";
import { Typography } from '@material-ui/core';

const IconMap = {
  home: iconHabitation,
  flight: iconSanteMob,
  mutual: iconMutuelle,
  rc: iconRc,
  laptop: iconMultimedia,
};

const useStyles = makeStyles(theme => ({
  cardWrapper: {
    textDecoration: 'none',
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
    marginRight: '20px',
    marginLeft: '20px',
    [theme.breakpoints.down('sm')]: {
      marginRight: '0px',
      marginLeft: '0px',
    },
  },
  newBadge: {
    position: 'absolute',
    top: '12px',
    right: '-4px',
    backgroundColor: '#FF6B35',
    color: '#ffffff',
    fontFamily: "'Montserrat', sans-serif",
    fontWeight: 700,
    fontSize: '10px',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    padding: '4px 10px',
    borderRadius: '20px',
    zIndex: 10,
    boxShadow: '0 2px 8px rgba(255, 107, 53, 0.4)',
  },
  card: {
    backgroundColor: '#2F6472',
    borderRadius: '60px',
    width: '200px',
    minHeight: '340px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '28px 24px 32px',
    boxSizing: 'border-box',
    cursor: 'pointer',
    transition: 'transform 0.25s ease, box-shadow 0.25s ease',
    boxShadow: '0 8px 24px rgba(47, 100, 114, 0.25)',
    '&:hover': {
      transform: 'translateY(-6px)',
      boxShadow: '0 16px 36px rgba(47, 100, 114, 0.35)',
    },
    // Responsive : plus compact sur mobile
    [theme.breakpoints.down('sm')]: {
      width: '120px',
      minHeight: '180px',
      borderRadius: '36px',
      padding: '16px 12px 20px',
    },
  },
  iconCircle: {
    width: '68px',
    height: '68px',
    borderRadius: '50%',
    backgroundColor: '#4CAF50',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '28px',
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      width: '44px',
      height: '44px',
      marginBottom: '14px',
    },
  },
  title: {
    color: '#ffffff',
    fontFamily: "'Montserrat', sans-serif",
    fontWeight: 700,
    fontSize: '18px',
    textTransform: 'uppercase',
    textAlign: 'center',
    letterSpacing: '0.5px',
    lineHeight: '1.4',
    margin: '0 0 16px 0',
    [theme.breakpoints.down('sm')]: {
      fontSize: '11px',
      letterSpacing: '0.3px',
    },
  },
  startingFrom: {
    textAlign: 'center',
    fontFamily: '"Roboto", Sans-serif',
    fontSize: '16px',
    fontWeight: 400,
    color: '#ffffff',
    marginBottom: '12px',
    '& strong, & b': {
      fontSize: '20px',
      fontWeight: 700,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '10px',
      letterSpacing: '0.3px',
      '& strong, & b': {
        fontSize: '11px'},
    },
  },
  describe: {
    textAlign: 'center',
    fontFamily: '"Roboto", Sans-serif',
    fontSize: '12px',
    fontWeight: 400,
    color: '#D9D9D9',
    fontStyle: 'italic',
    margin: 0,
    [theme.breakpoints.down('sm')]: {
      fontSize: '9px'    },
  }
}));

export const CardLink = ({ text,describe, startingFrom, link, icon, color, newO }) => {
  const classes = useStyles();
  const iconSrc = IconMap[icon] || null;

  return (
    <Link to={link} className={classes.cardWrapper}>
      {newO && <img style={{position: "absolute", width: "55px", top: -16,right: 0,zIndex: 1,borderRadius: 3}}src={newOffer} alt="new..." />}
      <div className={classes.card} style={{ backgroundColor: color || '#2F6472' }}>
        <div className={classes.iconCircle}>
          {iconSrc && (
            <img
              src={iconSrc}
              alt={text}
              className={classes.iconImg}
            />
          )}
        </div>
        <Typography variant="subtitle1" className={classes.title}>{text}</Typography>
        <Typography variant="body2" className={classes.startingFrom} dangerouslySetInnerHTML={{ __html: startingFrom }} />
        <Typography variant="body2" className={classes.describe}>{describe}</Typography>
      </div>
    </Link>
  );
};
